import * as WebBrowser from 'expo-web-browser';
import * as React from 'react';
import { Alert, Platform, StyleSheet, ToastAndroid } from 'react-native';
import {
  Box,
  Heading,
  Center,
  Stack,
  Spacer,
  Button,
  ChevronRightIcon,
  Radio,
  Text,
  FormControl,
  Input,
  VStack,
  KeyboardAvoidingView,
  ScrollView,
  HStack
} from 'native-base';
import { FormContext } from '../../stores/Store.tsx';
import PreLoader from '../../components/PreLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { isFormEnded } from '../../hooks/isFormEnd';

var numeral = require('numeral');


export default function TransmissionAxisScreen(props) {
  const { navigation } = props;
  let [form, setForm] = React.useContext(FormContext);
  const [formData, setFormData] = React.useState({});
  const [working, setWorking] = React.useState(false);

  const handleChange = (data) => {
    setFormData((prev) => {
      return {
        ...prev, ...data
      }
    });
  }
  const handleChangeForm = (data) => {
    const formData = { ...form }
    formData.questions.transmission_axis = { data, order: 8 };
    console.log(formData);
    setForm({ ...form, ...formData });
  }

  const continueForm = () => {
    handleChangeForm(formData)
    if (formData.double_bottom_transmission_axis.value || formData.strange_object_transmission_axis.value) {
      setWorking(true)
      form.endAt = new Date();
      isFormEnded(() => navigation.navigate('HomeScreen'), form)
    } else {
      navigation.navigate('ExhaustPipeScreen')
    }

  }


  if (working) {
    return <PreLoader />;
  }


  return (
    <Center flex={1}>
      <SafeAreaView style={{ flex: 1, padding: 10 }}>
        <KeyboardAvoidingView
          h={{
            // base: "400px",
            lg: "auto",
          }}
          behavior={Platform.OS === "ios" ? "padding" : "height"}
        >
          <VStack
            rounded="lg"
            overflow="hidden"
            width={{
              base: 'xs',
              sm: 'xl',
              md: 768,
              lg: 992,
              xl: 1280,
            }}
            height="full"
            shadow={1}
            _light={{ backgroundColor: 'gray.50' }}
            _dark={{ backgroundColor: 'gray.700' }}
            flex="1"
            justifyContent="flex-end"
          >
            <ScrollView
              _contentContainerStyle={{
                px: "20px",
                mb: "4",
                minW: "72",
              }}
            >
              <Stack p="4" space={3}>
                <Stack space={2}>
                  <Heading size="md" ml="-1">
                    {`Inspector: ${form.inspector}`}
                  </Heading>
                </Stack>
                <Text fontWeight="400">
                  {`Criterios para evaluar las preguntas siguientes responde `}
                  <Text fontWeight="bold">SI </Text>
                  <Text >o</Text>
                  <Text fontWeight="bold"> NO </Text>
                  {`según corresponda`}
                </Text>
                <Text fontWeight="400">
                  {`8) Eje de transmisión`}
                </Text>
                <FormControl>
                  <Stack space={2}>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>Se dectecta algún compartimiento secreto o doble fondo</FormControl.Label>
                        <Radio.Group
                          name="myRadioGroup"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ double_bottom_transmission_axis: { value: nextValue, q: 'Se dectecta algún compartimiento secreto o doble fondo', critic: true } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.double_bottom_transmission_axis.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl>
                      <VStack>
                        <FormControl.Label>Se observa soldadura reciente</FormControl.Label>
                        <Radio.Group
                          name="myRadioGroup"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ welding_recent_transmission_axis: { value: nextValue, q: 'Se observa soldadura reciente' } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </VStack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.welding_recent_transmission_axis.observations = text} placeholder="Observaciones" />
                    </Stack>
                    <FormControl isRequired>
                      <Stack>
                        <FormControl.Label>Se detecta algún artefacto sospechoso en el eje de transmisión</FormControl.Label>
                        <Radio.Group
                          name="myRadioGroup"
                          accessibilityLabel=""
                          onChange={(nextValue) => {
                            handleChange({ strange_object_transmission_axis: { value: nextValue, q: 'Se detecta algún artefacto sospechoso en el eje de transmisión', critic: true } })
                          }}
                        >
                          <Radio colorScheme="warning" value={true} my={1}>
                            <Text ml='2' fontSize="lg" style={{ color: 'red' }}>SI</Text>
                          </Radio>
                          <Radio value={false} my={1}>
                            NO
                          </Radio>
                        </Radio.Group>
                      </Stack>
                    </FormControl>
                    <Stack>
                      <FormControl.Label>Observaciones (en caso de no cumplir mencionarlo)</FormControl.Label>
                      <Input onChangeText={(text) => formData.strange_object_transmission_axis.observations = text} placeholder="Observaciones" />
                    </Stack>

                  </Stack>
                </FormControl>
              </Stack>
            </ScrollView>
            <Spacer />
            <Box>
              <HStack>
                <Spacer />
                <Button
                  disabled={formData.strange_object_transmission_axis === undefined ||
                    formData.welding_recent_transmission_axis === undefined
                    || formData.double_bottom_transmission_axis === undefined
                  }
                  rightIcon={<ChevronRightIcon color="white" />}
                  colorScheme={formData.strange_object_transmission_axis !== undefined &&
                    formData.welding_recent_transmission_axis !== undefined &&
                    formData.double_bottom_transmission_axis !== undefined
                    ? "info" : "gray"
                  }
                  size="md"
                  onPress={() => continueForm()}
                >
                  Continuar
                </Button>
              </HStack>

            </Box>
          </VStack>
        </KeyboardAvoidingView>
      </SafeAreaView>
    </Center>
  );
}
